import { ComponentType, lazy } from "react";
import { withRouter } from "react-router-dom";

export default function withLazyComponent<T>(importComponent: () => Promise<{ default: ComponentType<T> }>) {
  const LazyComponent = lazy(importComponent);

  function WithLazyComponent(props: any) {
    return (
      <div className="tw-h-full  tw-w-full tw-overflow-auto">
        <LazyComponent {...props} />
      </div>
    );
  }
  return withRouter(WithLazyComponent);
}
